<template>
    <div class="input-group | vn-input-checkbox checkboxes-group" :class="cssInputClass">
        <label :for="instanceId" v-html="field.title"></label>

        <div :class="'radio-groups num-groups_' + field.value_list.length ">
            <div class="radio-group" v-for="prop in field.value_list">
                <input
                    :name="key + '[]'"
                    :id="instanceId + '_' + prop.key"
                    type="checkbox"
                    :value="prop.key"
                    @blur="clearError"
                    v-model="compiledValues"
                    @change="adjustAfterChange"
                />
                <label class="checkbox-label" :for="instanceId + '_' + prop.key"><span v-html="prop.label"></span></label>
            </div>
        </div>

        <span class="error-message" v-if="gotError"> {{ errorMessage }} </span>
    </div>
</template>

<script>


export default {
    name : "InputCheckboxes",

}
</script>

<script setup>
import { onMounted, ref } from 'vue';

let instanceId = ref( null );

import useFormInput from "../../composables/useFormInput";
import { uniqueId } from 'lodash-es';

let props = defineProps( [ "field" ] );

let { gotError, clearError, cssInputClass, errorMessage, value, key, exposed } = useFormInput( props );

defineExpose( exposed );

let compiledValues = ref([]);
function adjustAfterChange() {
    value.value = compiledValues.value;
}

onMounted( () =>
{

    console.log('Ther\'re heeere');
    if ( instanceId.value === null )
    {
        instanceId.value = uniqueId( props.field.key + '_' );
    }
} )
</script>
